import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { Observable, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { TableVirtualScrollStrategyService } from 'src/app/services/virtual-scoll/table-virtual-scroll-strategy.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import {CustomTableHeader} from '../../classes/json-interface';

/**
 * Pour le virtual scroll:
 * Fonction mais impossible de gerer le header et la longueure des
 * celules peuvent changé en fonction des données enregistrée
 *
 */
@Component({
  selector: 'app-custom-mat-list',
  templateUrl: './custom-mat-list.component.html',
  styleUrls: ['./custom-mat-list.component.css'],
  providers: [{
    provide: VIRTUAL_SCROLL_STRATEGY,
    useClass: TableVirtualScrollStrategyService,
  }]
})
export class CustomMatListComponent<T> implements OnInit {

  @ViewChild('MatTable', { static: false }) HTML_Table!: MatTable<T>;
  @ViewChild('TablePaginator', { static: true }) HTML_Paginator!: MatPaginator;

  mUseVirtualScrool: boolean = false;
  mUsePaginator: boolean = false;

  mCustomList: CustomList;
  mVSCustomList: VirtualScrollCustomList;


  constructor(@Inject(VIRTUAL_SCROLL_STRATEGY) readonly scrollStrategy: TableVirtualScrollStrategyService) {
    this.mVSCustomList = new VirtualScrollCustomList(scrollStrategy);
    this.mCustomList = new CustomList();
  }

  ngOnInit() {
    this.usePaginator = true;
  }

  public setScroolHeight(rowHeight: number, headerHeight: number) {
    if (this.mUseVirtualScrool) {
      this.mVSCustomList.setScroolHeight(rowHeight, headerHeight);
    }
  }

  public setRows(rows: any[]) {
    if (this.mUseVirtualScrool) {
      this.mVSCustomList.setRows(rows);
    } else {
      this.mCustomList.setRows(rows);
    }
  }

  public setHeader(useless: string[], tableTextColumns: CustomTableHeader[]) {
    const arrayHeaderName: string[] = [];
    if (tableTextColumns) {
      tableTextColumns.forEach(header => {
        arrayHeaderName.push(header.Name);
      });
    }

    if (this.mUseVirtualScrool) {
      this.mVSCustomList.setHeader(arrayHeaderName, tableTextColumns);
    } else {
      this.mCustomList.setHeader(arrayHeaderName, tableTextColumns);
    }
  }

  public get gridHeight() {
    return this.mVSCustomList.gridHeight;
  }

  public clearTable() {
    this.setRows([]);
    this.setHeader([], []);
  }

  public set usePaginator(val: boolean) {
    this.mUsePaginator = val;
    if (!this.mUseVirtualScrool) {
      if (val) {
        (this.HTML_DataSource as MatTableDataSource<any>).paginator = this.HTML_Paginator;
      } else {
        (this.HTML_DataSource as MatTableDataSource<any>).paginator = null;
      }
    }
  }

  /**
   * Définir si on utiliser un tableau clasique ou
   * un tableau avec le virtual scroll (en test)
   */
  public set useVirtualScroll(val: boolean) {
    this.mUseVirtualScrool = val;
  }

  public get HTML_DataSource(): MatTableDataSource<any>|Observable<Array<any>> {
    if (this.mUseVirtualScrool) {
      return this.mVSCustomList.HTML_dataSource;
    } else {
      return this.mCustomList.HTML_dataSource;
    }
  }

  public get HTML_VirtualDataSoruce(): Observable<Array<any>> {
    if (this.mUseVirtualScrool) {
      return this.mVSCustomList.HTML_VirtualDataSource;
    } else {
      console.error('no virtual datasource on classic list');
      return of([]);
    }
  }

  public get HTML_DynamicHeader(): CustomTableHeader[] {
    if (this.mUseVirtualScrool) {
      return this.mVSCustomList.HTML_TableTextColumns;
    } else {
      return this.mCustomList.HTML_DynamicHeader;
    }
  }

  public get HTML_ArrayHeaderRef(): string[] {
    if (this.mUseVirtualScrool) {
      return this.mVSCustomList.HTML_TableColumns;
    } else {
      return this.mCustomList.HTML_ArrayHeaderName;
    }
  }

}

export class CustomList {

  HTML_dataSource: MatTableDataSource<any>;
  HTML_DynamicHeader: CustomTableHeader[];
  HTML_ArrayHeaderName: string[];

  constructor() {
    this.HTML_dataSource = new MatTableDataSource<any>([]);
    this.HTML_DynamicHeader = [];
    this.HTML_ArrayHeaderName = [];
  }

  public setRows(rows: any[]) {
    this.HTML_dataSource.data = rows;
  }

  public setHeader(headerName: string[], tableTextColumns: CustomTableHeader[]) {
    this.HTML_ArrayHeaderName = headerName;
    this.HTML_DynamicHeader = tableTextColumns;
  }
}

/**
 * Pour le cas ou on utiliser le virtual scool pour gerer les grose donnée
 */
export class VirtualScrollCustomList {

  // Manually set the amount of buffer and the height of the table elements
  static BUFFER_SIZE = 3;
  rowHeight = 48;
  headerHeight = 56;

  HTML_TableColumns: string[] = [];

  HTML_dataSource: Observable<Array<any>> = of([]);
  HTML_VirtualDataSource: Observable<Array<any>> = of([]);

  HTML_TableTextColumns: CustomTableHeader[];

  gridHeight = 400;

  constructor(
    private readonly scrollStrategy: TableVirtualScrollStrategyService
  ) {
    this.HTML_TableTextColumns = [];
  }

  public setScroolHeight(rowHeight: number, headerHeight: number) {
    this.scrollStrategy.setScrollHeight(rowHeight, headerHeight);
  }

  // new Array(1000).fill({position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'})
  public setRows(rows: any[]) {
    console.log('SetRows', rows);
    this.HTML_VirtualDataSource = of(rows);
    const range = Math.ceil(this.gridHeight / this.rowHeight) + VirtualScrollCustomList.BUFFER_SIZE;
    this.HTML_dataSource = combineLatest([this.HTML_VirtualDataSource, this.scrollStrategy.scrolledIndexChange]).pipe(
      map((value: any) => {

        // Determine the start and end rendered range
        const start = Math.max(0, value[1] - VirtualScrollCustomList.BUFFER_SIZE);
        const end = Math.min(value[0].length, value[1] + range);

        // Update the datasource for the rendered range of data
        return value[0].slice(start, end);
      })
    );
    setTimeout(() => {
      this.scrollStrategy.onContentScrolled();
    });
  }

  public setHeader(tableColumns: string[], tableTextColumns: CustomTableHeader[]) {
    this.HTML_TableColumns = tableColumns;
    this.HTML_TableTextColumns = tableTextColumns;
  }

}

export interface ArmaWebTable {
  'Data': any;
  'Header': CustomTableHeader[];
}

